import { TypeKeys } from '../actions/index.js';
import type { ReportsState } from '../../common/types/states.js';
import type { ActionTypes } from '../actions/index.js';
import type { ActionsHistory } from '../common/store.js';

export function reportsReducer(
  state: (ReportsState & ActionsHistory) | undefined,
  action: ActionTypes
): (ReportsState & ActionsHistory) | null {
  if (typeof state === 'undefined') {
    return null;
  }

  switch (action.type) {
    case TypeKeys.POLL_FOR_MYSELF_CHANGES_FULFILLED: {
      if (action.reportStatusChange) {
        return {
          ...state,
          latestReportStatusChange: action.reportStatusChange,
        };
      }
      return state;
    }

    default:
      return state;
  }
}
